import React from "react";
import { Box, Typography } from "@mui/material";
import {
  DescriptionOutlined,
  InsertDriveFileOutlined,
  PictureAsPdfOutlined,
} from "@mui/icons-material";
import { colors } from "../../theme/theme";

const getExtension = (fileName = "") => {
  const parts = fileName.split(".");
  return parts.length > 1 ? parts.pop().toUpperCase() : "FILE";
};

const DocumentFilePreview = ({ fileName, height = "140px", iconSize = "40px" }) => {
  const ext = getExtension(fileName);
  const Icon =
    ext === "PDF"
      ? PictureAsPdfOutlined
      : ext === "DOC" || ext === "DOCX"
      ? DescriptionOutlined
      : InsertDriveFileOutlined;

  return (
    <Box
      sx={{
        width: "100%",
        height,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255,255,255,0.05)",
        gap: 1,
      }}
    >
      <Icon sx={{ color: colors.secondary, fontSize: iconSize }} />
      <Typography
        sx={{
          color: "rgba(255,255,255,0.6)",
          fontFamily: "Mulish-SemiBold",
          fontSize: "12px",
        }}
      >
        {ext}
      </Typography>
    </Box>
  );
};

export default DocumentFilePreview;
